import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SebbieTask } from 'src/app/models/sebbietask.model';
import { TaskDetailDialogComponent } from '../task-detail-dialog/task-detail-dialog.component';

@Component({
  selector: 'task-card',
  templateUrl: './task-card.component.html',
  styleUrl: './task-card.component.scss'
})
export class TaskCardComponent {
  @Input() task: SebbieTask
  @Input() completedCount: number = 0;
  @Input() numberInList: number = 0;

  constructor(
    private readonly dialog: MatDialog
  ) { }

  openTaskDetailDialog(): void {
    this.dialog.open<TaskDetailDialogComponent>(TaskDetailDialogComponent, {
      autoFocus: false, // To prevent select state of close button in header
      data: {
        tasknumber: this.numberInList,
        task: this.task,
        completedCount: this.completedCount
      }
    });
  }
}
